/**
 * Badge Component - Compatible avec styled-components
 * Utilisé pour les tests UI
 */

import React from 'react';
import styled from 'styled-components';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
}

const StyledBadge = styled.div<{ $variant?: string }>`
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  transition: all 0.2s;

  ${props => {
    switch (props.$variant) {
      case 'secondary':
        return `
          background: #f5f5f5;
          color: #333;
        `;
      case 'destructive':
        return `
          background: #ff4d4f;
          color: white;
        `;
      case 'outline':
        return `
          background: transparent;
          border: 1px solid #d9d9d9;
          color: #333;
        `;
      default:
        return `
          background: #1890ff;
          color: white;
        `;
    }
  }}
`;

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ variant = 'default', className, ...props }, ref) => {
    return (
      <StyledBadge
        ref={ref}
        $variant={variant}
        className={className}
        {...props}
      />
    );
  }
);

Badge.displayName = 'Badge';
